import React from "react";

const PageFrame = ({ source }) => {
  const toolbar = document.getElementById("appBar");
  const toolbarHeight = toolbar ? toolbar.offsetHeight : 0;
  const adminBar = document.getElementById("wpadminbar");
  const adminBarHeight = adminBar ? adminBar.offsetHeight : 0;
  return (
    <div
      style={{
        width: "100%",
        height: window.innerHeight - toolbarHeight - adminBarHeight
      }}
    >
      <iframe
        width="100%"
        height="100%"
        title={window.t["Active tab"]}
        src={source}
        frameBorder="0"
        style={{ overflow: "hidden" }}
      />
    </div>
  );
};

export default PageFrame;
